import { render } from "./TableForCatalog.vue?vue&type=template&id=0e299674&scoped=true"
import script from "./TableForCatalog.vue?vue&type=script&lang=js"
export * from "./TableForCatalog.vue?vue&type=script&lang=js"

import "./TableForCatalog.vue?vue&type=style&index=0&id=0e299674&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e299674"]])

export default __exports__